import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Curriculumleft from './Curriculumleft';

const Btech_curriculumEle = () => {

    const curriculumData = [
        {
            department: "Engineering Physics",
            curricula: [
                {
                    batch: "2024 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2024/EP.pdf",
                },
            ],
        },

        {
            department: "Chemical Engineering",
            curricula: [
                {
                    batch: "2023 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2024/CH.pdf",
                },
                {
                    batch: "2019 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_CH_New.pdf",
                },
                {
                    batch: "2018 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/BTechCurriculum-CH.pdf",
                },
            ],
        },

        {
            department: "Civil Engineering",
            curricula: [
                {
                    batch: "2023 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2024/CEE_CURRICULUM_05.03.2024.pdf",
                },
                {
                    batch: "2019 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_CE_New.pdf",
                },
                {
                    batch: "2018 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/Curriculum-Civil-2018.pdf",
                },
                {
                    batch: "2016 Batch Onwards",
                    url: "https://files.iittp.ac.in/images/demo/iit/curriculums/CE_Curriculum_2016.pdf",
                },
                {
                    batch: "2015 Batch Onwards",
                    url: "https://files.iittp.ac.in/images/demo/iit/curriculums/CE_Curriculum_2015.pdf",
                },
            ],
        },

        {
            department: "Computer Science Engineering",
            curricula: [
                {
                    batch: "2024 Batch Onwards",
                    url: "https://files.iittp.ac.in/2026/academic/curriculum/B.Tech_CSE_2024_onwards.pdf",
                },
                {
                    batch: "2023 Batch Onwards",
                    url: "https://files.iittp.ac.in/2026/academic/curriculum/B.Tech_CSE_2023_onwards.pdf",
                },
                {
                    batch: "2019 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_CS_New.pdf",
                },
                {
                    batch: "2018 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/Curriculum-CSE-2018.pdf",
                },
                {
                    batch: "2017 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/cse_curriculum_batch_2017.pdf",
                },
                {
                    batch: "2016 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/cse_curriculum_2016_batch.pdf",
                },
                {
                    batch: "2015 Batch Onwards",
                    url: "https://files.iittp.ac.in/images/demo/iit/curriculums/CSE_Curriculum.pdf",
                },
            ],
        },

        {
            department: "Electrical Engineering",
            curricula: [
                {
                    batch: "2023 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2024/EE.pdf",
                },
                {
                    batch: "2019 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_EE_New.pdf",
                },
                {
                    batch: "2018 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/Curriculum-EE-2018.pdf",
                },
                {
                    batch: "2016 Batch Onwards",
                    url: "https://files.iittp.ac.in/images/demo/iit/curriculums/EE-Curriculum-2016.pdf",
                },
                {
                    batch: "2015 Batch Onwards",
                    url: "https://files.iittp.ac.in/images/demo/iit/curriculums/EE-Curriculum-2015.pdf",
                },
            ],
        },

        {
            department: "Mechanical Engineering",
            curricula: [
                {
                    batch: "2023 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2024/ME_CURRICULUM_05.03.2024.pdf",
                },
                {
                    batch: "2019 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/2019/B.Tech%20Curriculum-2019_ME_Updated.pdf",
                },
                {
                    batch: "2018 Batch Onwards",
                    url: "https://files.iittp.ac.in/pdfs/curriculum/Curriculum-ME-2018.pdf",
                },
                {
                    batch: "2015 Batch Onwards",
                    url: "https://files.iittp.ac.in/images/demo/iit/curriculums/ME_Curriculum.pdf",
                },
            ],
        },
    ];


    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Curriculumleft activeIndex={0} />
                    </Col>

                    <Col md={8} className='c-right mt-2 ps-5'>
                        <h3 className='text-center mb-5'>B.Tech Curriculum</h3>
                        <h5>Curriculum for B.Tech Programs are listed as below:</h5>
                        <div className="table-responsive mt-4">
                            <table className="table table-bordered table-hover align-middle">
                                <thead className="table-primary text-center">
                                    <tr>
                                        <th width="8%">S.No.</th>
                                        <th width="42%">Department</th>
                                        <th width="50%">Batch</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {curriculumData.map((dept, deptIndex) =>
                                        dept.curricula.map((item, itemIndex) => (
                                            <tr
                                                key={`${deptIndex}-${itemIndex}`}
                                                className={deptIndex % 2 === 0 ? "table-light" : "table-secondary"}
                                            >
                                                {itemIndex === 0 && (
                                                    <>
                                                        <td
                                                            rowSpan={dept.curricula.length}
                                                            className="text-center align-middle fw-bold"
                                                        >
                                                            {deptIndex + 1}
                                                        </td>

                                                        <td
                                                            rowSpan={dept.curricula.length}
                                                            className="align-middle fw-bold"
                                                        >
                                                            {dept.department}
                                                        </td>
                                                    </>
                                                )}

                                                <td>
                                                    <Link
                                                        to={item.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-decoration-none"
                                                    >
                                                        <i className="fas fa-file-pdf text-danger me-2"></i>
                                                        {item.batch}
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>

    );
};


export default Btech_curriculumEle;
